import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export const getFastboundFileContent = (name: string): Promise<Blob> => {
    return api.get(`/v2/subscriptions/fastbound/files/${name}`, {
        responseType: 'blob'
    })
}

export const getFastboundFileContentQueryOptions = (name: string) => {
    return queryOptions({
        queryKey: ['fastbound-file-content', name],
        queryFn: () => getFastboundFileContent(name),
    })
}

type UseFastboundFileContentOptions = {
    name: string
    queryConfig?: QueryConfig<typeof getFastboundFileContent>
}

export const useFastboundFileContent = ({ name, queryConfig }: UseFastboundFileContentOptions) => {
    return useQuery({
        ...getFastboundFileContentQueryOptions(name),
        enabled: Boolean(name),
        ...queryConfig,
    })
}

